import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

export const exportsRoutes: MenuInterface[] = [
    {
        code: 'GestionRequeteSpecifique_ViewModel',
        route: [
            {
                content: 'exports/requests/filters',
                focus: 'empty'
            }, 'content'
        ]
    },
    {
        code: 'Kibana_ViewModel',
        route: [
            {
                content: 'exports/decision-analysis',
                focus: 'empty'
            }, 'content'
        ]
    },

];
